import React from 'react';
import { Button } from 'tea-component';
import { useIntl, getLocale } from 'umi';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';

export default function SpecialColContent(props) {
  const {
    context,
    config,
    hideCond,
    getIsHideCol,
    onGameItemClick,
    textFormatter,
    isLabelHide
  } = props;

  const {
    type,
    key,
    clickKey,
    align = 'right',
    childWidth,
    childAlign
  } = config || {};

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isHide = hideCond && (getIsHideCol instanceof Function) && getIsHideCol(hideCond, context, 'specicalContent');
  const getElContent = (_type: string) => {
    if (!!isHide) return null;
    switch (_type) {
      // 文本来源于接口，所以中英翻译要借助字段转换
      case 'text':
        const name = context[key];
        const nameCn = context[`${key}_cn`] || name;
        let displayName = name;
        if (locale === 'zh-CN') {
          displayName = nameCn;
        }
        if (textFormatter instanceof Function) {
          displayName = textFormatter(name, key, context) || displayName;
        }
        return (
          <span style={{
            display: isLabelHide ? 'none' : ''
          }}>{displayName}</span>
        )
      case 'action':
        return (
          <Button
            className="table-link"
            style={{
              display: isLabelHide ? 'none' : ''
            }}
            onClick={() => {
              if (onGameItemClick instanceof Function) {
                onGameItemClick(clickKey, context);
              }
            }}
            type="link"
          >
            {formatMessage({ id: key })}
          </Button>
        )
      default:
        return null;
    }
  }
  return (
    <>
      {
        align === 'center'
          ? <CloumsCenter width={childWidth} align={childAlign}>
            {getElContent(type)}
          </CloumsCenter>
          : getElContent(type)
      }
    </>
  )
}
